export const ADDITIONAL_SERVICES_KEYS: any = {
    hasCar: 'car',
    hasSoftPackage: 'soft_package',
    hasManipulator: 'manipulator',
    hasCrane: 'crane',
    hasHydraulicTrolley: 'hydraulic_trolley',
    hasGrid: 'grid',
    hasLoader: 'loader',
    hasPallet: 'pallet',
}
